import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import isEqual from 'lodash.isequal';
import { getTranslations } from 'b2b-apps/shop/i18n/redux/selectors';
import { getTranslatedText, TranslateFunction } from 'b2b-server/core/utils/language';

const useTranslate = (): TranslateFunction => {
  const translations = useSelector(getTranslations, isEqual);

  return useCallback(
    (key, params) => getTranslatedText(translations, key, params),
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};


export {
  getTranslatedText,
  useTranslate,
};
